import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.2 4.805c.519-.137 1.093.11 1.284.629l1.094 2.625c.192.437.082.957-.3 1.257l-1.34 1.121a9.2 9.2 0 0 0 4.374 4.376l1.122-1.34c.3-.383.82-.493 1.257-.301l2.625 1.094c.493.191.766.765.63 1.285l-.657 2.406a1.08 1.08 0 0 1-1.039.793A12.23 12.23 0 0 1 5 6.5c0-.492.328-.902.793-1.04zm8.421.136L18.81 7.13c.246.273.246.684 0 .93l-2.188 2.187c-.273.274-.683.274-.93 0-.273-.246-.273-.656 0-.93l1.067-1.066H13.53a.63.63 0 0 1-.656-.656c0-.356.273-.657.656-.657h3.227L15.69 5.872a.6.6 0 0 1 0-.902.6.6 0 0 1 .903 0z"
    }, null, -1)
  ]))]))
}
export default { render: render }